import EventManager from "../../../../manager/event_manager";
import ModelData, { IUserData } from "../../../public/model_data";
import UserDataManager from "../../../../manager/user_manager";
import ViewBase from "../../../../framework/core/mvvm/view_base";
import { Notify } from "../../server/notify/proto_notify";

const {ccclass, property} = cc._decorator;

@ccclass
export default class PlayerChatItem extends ViewBase {
    
    

    @property(cc.Sprite)
    icon: cc.Sprite = null;

    @property(cc.Label)
    playerNameTxt: cc.Label = null;
    
    @property(cc.Label)
    lastMsg: cc.Label = null;

    @property(cc.Button)
    delBtn: cc.Button = null;

    moveSpeed: number;
    startTime: number;
    leftPosX=-91
    isMove:number=0;//1 左 0 中 2 右边,3-中间状态

    sendUserId=0
    recverUserId=0
    msg:string=""
    index=0
    // LIFE-CYCLE CALLBACKS:

    // onLoad () {}

    start () {

        this.node.on(cc.Node.EventType.TOUCH_START,this.touchstart,this);
        this.node.on(cc.Node.EventType.TOUCH_MOVE,this.touchMove,this);
        this.node.on(cc.Node.EventType.TOUCH_END,this.touchEnd,this);
        this.node.on(cc.Node.EventType.TOUCH_CANCEL,this.touchEnd,this);
        this.delBtn.node.on('click', this.onClick_del, this);
       

    }
    onClick_del()
    {
        EventManager.instance.dispatch("del_chat_playerItem", this.index)
    }
    touchstart(event)
    {
        this.moveSpeed = 0;
        this.startTime = new Date().getTime();
        //cc.log("start")
    }
    touchMove(event)
    {
 
        if(this.isMove == 3)
        {
            return
        }
        let self=this
   
        let movePos = event.getDelta();
        if(movePos.x>0)
        {
            if(this.isMove == 0 )
            {
                return
            }

            this.isMove = 3
            let moveTo2 = cc.moveTo(0.5, cc.v2(0,0));
            this.node.runAction(cc.sequence(moveTo2,cc.callFunc(()=>{
                this.isMove=0
            })));

        }
        else
        {
            if(this.isMove == 1)
            {
                return
            }
            this.isMove=3
   
             let moveTo2 = cc.moveTo(0.5, cc.v2(-150,0));
            this.node.runAction(cc.sequence(moveTo2,cc.callFunc(()=>{
                this.isMove=1
            })));
        }
    }
    touchEnd(event)
    {
        // this.isMove=false
        let curpos = event.getLocation();
        let startpos = event.getStartLocation();
        let dis= startpos.x - curpos.x;
        if(dis==0) //点击某人具体聊天记录
        {
            EventManager.instance.dispatch("click_playerChatItem", this.sendUserId,this.recverUserId)
        }
    }
    setData(index,chatMsg:Notify.ChatMessage) {
        this.index=index
        let playerId
        if(chatMsg.recverUserId==ModelData.instance.roleData.id)
        {
            playerId=chatMsg.sendUserId
        }
        else
        {
            playerId=chatMsg.recverUserId
        }
        this.recverUserId=chatMsg.recverUserId
        this.sendUserId=chatMsg.sendUserId
        //UserDataManager.setUserJsonData(this.posInfo.userJson)
        this.getUserData(playerId, (data : IUserData)=> {
            this.playerNameTxt.string = data.name
            this.icon.spriteFrame = data.avatarSprite
            
            //this.playerItems[playerObjIndex].Icon.node
        })
         this.lastMsg.string=chatMsg.content
    }
    refreshMsg(content: string) {
        this.lastMsg.string=content;
    }
    // update (dt) {}
}
